import { GridColumnVisibilityModel } from '@mui/x-data-grid';

export const REDISCOVERY_ACTIONS_COLUMN_FIELD = '__actions__';

export const REDISCOVERY_DEFAULT_COLUMN_VISIBILITY_MODEL: GridColumnVisibilityModel =
  {
    // Always-visible columns
    fullName: true,
    latestApplicationHistory: true,
    tags: true,
    [REDISCOVERY_ACTIONS_COLUMN_FIELD]: true,
  };
